import { API } from '@shared/types/api';
import { ReactionButtonWithPicker } from '../components/reaction/ReactionButtonWithPicker';
import { useSelectedReactions, useToggleReaction } from './hooks';

type OwnProps = Omit<
  ReactionButtonWithPicker['props'],
  'onToggleReaction' | 'selected' | 'anchorName'
> & {
  message: API.ChatMessageFragment;
  channelSlug: string;
  anchorName: string;
};

export function MBMessageReactionButton({ message, channelSlug, anchorName }: OwnProps) {
  const selected = useSelectedReactions(message);
  const toggleReaction = useToggleReaction(message, channelSlug);
  return (
    <ReactionButtonWithPicker
      anchorName={anchorName}
      selected={selected}
      onToggleReaction={toggleReaction}
      testID="chat-message-reaction-button"
    />
  );
}
